import { combineReducers } from 'redux';

import auth from './auth';
import devices from './devices';
import deviceSessions from './deviceSessions';
import facilities from './facilities';
import flow from './flow';
import logs from './logs';
import logTypes from './logTypes';
import sessionDevices from './sessionDevices';
import teams from './teams';
import teamSets from './teamSets';
import users from './users';

const rootReducer = combineReducers({
  auth,
  flow,
  users,
  teams,
  teamSets,
  devices,
  deviceSessions,
  sessionDevices,
  facilities,
  logs,
  logTypes,
});

export default rootReducer;
